import React from 'react'
import colors from './colors'
import I18n from 'lib/components/i18n'

import {
  CHART_DEBUG,
  LINE_HEIGHT,
  LABEL_PADDING,
  FONT_FAMILY
} from './constants'

class AxisLabel extends React.PureComponent {
  static defaultProps = {
    className: '',
    fontFamily: FONT_FAMILY,
    label: null,
    rotate: 0,
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    fill: colors.label
  }

  // Generate a debug outline for investigating layout miscalculations
  // Activate by adding `?debug=true` to the query string
  renderDebug(box) {
    const { width } = this.props

    return (
      <g fill="none" strokeDasharray="2 1">
        {/* box frame */}
        <rect
          width={width}
          height={box.height + LABEL_PADDING * 2}
          stroke="orange"
        />
        {/* upper padding */}
        <line
          x2={width}
          y1={LABEL_PADDING}
          y2={LABEL_PADDING}
          stroke="magenta"
        />
        {/* lower padding */}
        <line
          x2={width}
          y1={box.height + LABEL_PADDING}
          y2={box.height + LABEL_PADDING}
          stroke="magenta"
        />
      </g>
    )
  }

  getTopOffset(box) {
    const { rotate, y, height } = this.props

    // Identify the top anchor point by taking the height of the label (bottom)
    // and subtracting the box height + padding
    const top = height - (box.height + LABEL_PADDING * 2)

    // If rotated, calculate the cos to properly offset the rotation
    return y + Math.cos(rotate * (Math.PI / 180)) * top
  }

  renderLine(line, i) {
    const { width } = this.props

    // Center align the text
    const x = width * 0.5
    // Offset by the label padding, then the line number
    const y = LABEL_PADDING + LINE_HEIGHT * i
    // Vertically center according to our calculated line height, not the
    // the SVG line height
    const dy = LINE_HEIGHT * 0.5

    return (
      <I18n key={i} tag="text" x={x} y={y} dy={dy}>
        {line}
      </I18n>
    )
  }

  render() {
    const { className, label, fill, fontFamily, rotate, x } = this.props

    // Do not render if there is not an axis label
    if (!label || label.lines.length === 0) {
      return null
    }

    const top = this.getTopOffset(label)
    const transform = `translate(${x},${top}) rotate(${rotate})`

    return (
      <g
        className={`axis__label ${className}`}
        textAnchor="middle"
        dominantBaseline="central"
        transform={transform}
        fill={fill}
        fontFamily={fontFamily}
      >
        {CHART_DEBUG ? this.renderDebug(label) : null}
        {label.lines.map(this.renderLine, this)}
      </g>
    )
  }
}

export default AxisLabel



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/axis-label.js